import React from 'react';
import Link from 'next/link';
import Price from '../ui/Price';
import DetailIcon from '../ui/DetailIcon';
import { useTranslation } from '../../hooks/useTranslation';
import { productDate } from './productPresentation';

export default function ProductFulfilment({ product, shipping = {}, purchase, type = 'product' }) {
  const { t, locale } = useTranslation('product');
  const { mode, availability } = purchase;
  const release = productDate(product.availableFrom, locale);
  const min = productDate(shipping?.minDeliveryDate, locale);
  const max = productDate(shipping?.maxDeliveryDate, locale);
  const supplierDays = product.availabilitySupplier?.deliveryTime;
  let title = null, text = null, icon = 'truck';
  if (mode === 'auction') {
    title = t('delivery.auctionTitle'); text = t('delivery.auction'); icon = 'bid';
  } else if (availability === 'preorder') {
    title = t('delivery.preorderTitle'); text = release ? t('delivery.release').replace('{date}', release) : t('delivery.preorder'); icon = 'calendar';
  } else if (availability === 'supplier') {
    title = t('delivery.supplierTitle'); text = supplierDays ? t('delivery.supplierDays').replace('{days}', supplierDays) : t('delivery.supplier');
  } else if (availability === 'available' && type !== 'single' && !product.service && min && max) {
    title = t('delivery.estimate'); text = min === max ? min : `${min} – ${max}`;
  }
  return <div className="mt-6 space-y-3 text-xs leading-relaxed text-krit-surface">
    {title && <div className="flex gap-3"><DetailIcon name={icon} className="mt-0.5 h-5 w-5 shrink-0" /><div><p className="font-bold">{title}</p><p className="mt-1">{text}</p></div></div>}
    <div className={`space-y-2 ${title ? 'pl-8' : ''}`}>
      {availability === 'available' && mode === 'cart' && !product.service && shipping?.cost === 0 && <p className="font-semibold text-teal-800">{t('delivery.free')}</p>}
      {!product.service && product.excludeFromFreeDelivery ? <p>{t('delivery.excluded')}</p> : !product.service && mode === 'cart' && Number(shipping?.freeDeliveryThreshold) > 0 && shipping?.cost !== 0 ? <p>{t('delivery.freeAbove')} <Price amount={Number(shipping.freeDeliveryThreshold)} tone="inherit" /></p> : null}
      <Link href="/info/detalii-livrare" className="inline-flex min-h-[28px] items-center gap-1 font-semibold underline underline-offset-4">{t('delivery.link')} ↗</Link>
      {availability === 'preorder' && mode === 'cart' && <p>{t('delivery.preorderNote')}{!!product.prepay && <> {t('delivery.prepay')}</>}</p>}
    </div>
  </div>;
}
